// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { type PropsWithChildren } from "react";
import { Card } from "./ui/Card.js";

interface PanelProps extends PropsWithChildren {
  className?: string;
  elevated?: boolean;
}

export const Panel = ({ children, className, elevated = false }: PanelProps) => (
  <Card as="section" elevated={elevated} className={className}>
    {children}
  </Card>
);
